import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { Card } from "../../components/ui/card";
import { ArrowRight } from "lucide-react";
import Seo from "../../components/Seo";

const STEPS = [
  { t: "Add your income cycle", d: "Tell COMMITMENTT your monthly (or average monthly) income, your salary date, and an optional protected reserve. Variable income? Enter a conservative estimate." },
  { t: "Add or identify recurring commitments", d: "Add commitments manually, paste a bank or merchant message, or upload a screenshot for AI-assisted extraction. Every AI-detected item is shown to you for confirmation." },
  { t: "Review your monthly commitment position", d: "See what's committed this month, your commitment ratio, and an estimated safe-to-spend figure — all clearly labelled." },
  { t: "Act before renewals and deductions", d: "Review upcoming deductions, spot forgotten or unused commitments, and get gentle reminders before renewals." },
];

export default function HowItWorks() {
  const nav = useNavigate();
  return (
    <div className="max-w-3xl mx-auto px-5 py-14">
      <Seo title="How It Works" description="From scattered deductions to a single calm view — how COMMITMENTT works in four steps." />
      <span className="text-xs tracking-[0.2em] uppercase font-semibold text-mint">How it works</span>
      <h1 className="font-heading text-4xl font-light text-ink mt-3">From scattered deductions to a single, calm view.</h1>
      <p className="text-slatey mt-4 leading-relaxed">
        COMMITMENTT is not a budgeting app. It is a recurring financial commitment intelligence platform —
        it tells you what your income has already promised, before you spend it.
      </p>
      <div className="space-y-4 mt-10">
        {STEPS.map((s, i) => (
          <Card key={i} className="rounded-2xl border-border shadow-card-sm p-6 flex gap-5">
            <div className="h-10 w-10 rounded-full bg-mint-light text-mint flex items-center justify-center font-heading font-semibold shrink-0">{i + 1}</div>
            <div>
              <h3 className="font-heading text-lg font-medium text-ink">{s.t}</h3>
              <p className="text-sm text-slatey mt-1.5 leading-relaxed">{s.d}</p>
            </div>
          </Card>
        ))}
      </div>
      <div className="rounded-2xl bg-navy text-white p-8 mt-10">
        <p className="text-sm text-white/70">A note on safe-to-spend</p>
        <p className="mt-2 leading-relaxed">
          Safe-to-spend is an estimate based on the information you provide and confirm. It is not a live bank balance
          and it is not financial advice.
        </p>
      </div>
      <div className="flex flex-col sm:flex-row gap-3 mt-10">
        <Button className="rounded-full bg-navy text-white hover:bg-navy-light h-12 px-7" onClick={() => nav("/register")}>Get Started Free <ArrowRight size={18} className="ml-1" /></Button>
        <Button variant="secondary" className="rounded-full h-12 px-7 bg-secondary text-ink" onClick={() => nav("/demo")}>View Demo</Button>
      </div>
    </div>
  );
}
